import axios from 'axios';
import { co2optBaseUrl, tireServiceMapUrl, appTelemetryUrl } from './config.js';
import {
  customerAccountsTokenSelector,
  setAccessTokenSelector,
} from './redux/users/ducks.js';
import store from './redux/store.js';
import { decrypter } from './utils/Encrypter.js';

const co2OptBaseApi = axios.create({
  baseURL: co2optBaseUrl,
});
const setTokenForRequest = config => {
  const state = store.getState();

  const generalToken = setAccessTokenSelector(state);
  const specialToken =
    customerAccountsTokenSelector(state) ||
    (localStorage.getItem('static_access_token') &&
      decrypter(localStorage.getItem('static_access_token')));

  if (config.url.includes('fm-sign-in') && specialToken) {
    config.headers['Authorization'] = `Bearer ${specialToken}`;
  } else if (generalToken) {
    config.headers['Authorization'] = `Bearer ${generalToken}`;
  }

  return config;
};

const dropzoneApi = axios.create({
  baseURL: `${co2optBaseUrl}/customer/vehicle-data-room`,
});

const tireServiceMapApi = axios.create({
  baseURL: tireServiceMapUrl,
});

const appTelemetryApi = axios.create({
  baseURL: appTelemetryUrl,
});
co2OptBaseApi.interceptors.request.use(setTokenForRequest, error =>
  Promise.reject(error)
);

dropzoneApi.interceptors.request.use(
  config => {
    const state = store.getState();
    const token = setAccessTokenSelector(state); // Get the token using the selector

    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

tireServiceMapApi.interceptors.request.use(
  config => {
    const state = store.getState();
    const token = setAccessTokenSelector(state); // Get the token using the selector

    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

appTelemetryApi.interceptors.request.use(
  config => {
    const state = store.getState();
    const token = setAccessTokenSelector(state); // Get the token using the selector

    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
export { co2OptBaseApi, dropzoneApi, tireServiceMapApi, appTelemetryApi };
